module.exports = __webpack_public_path__ + "assets/img/swiper-6.45fc8c54.jpg";